"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* tslint:disable:forbid-import */
var satcheljs_1 = require("satcheljs");
/* tslint:enable:forbid-import */
var store_1 = require("../store/store");
var updateCategory_1 = require("../orchestrators/updateCategory");
exports.default = satcheljs_1.orchestratorAction('selectSubcategory', function selectSubcategory(subcategory) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var store;
        return tslib_1.__generator(this, function (_a) {
            store = store_1.getStore();
            updateCategory_1.default(store.currentCategoryKey, subcategory.key, null);
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=selectSubcategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-options-store/lib/orchestrators/selectSubcategory.js
// module id = 5277
// module chunks = 2